import { render, staticRenderFns } from "./VacationApprovedWidget.vue?vue&type=template&id=34194551&scoped=true&"
import script from "./VacationApprovedWidget.vue?vue&type=script&lang=js&"
export * from "./VacationApprovedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34194551",
  null
  
)

export default component.exports